/** 가격 포맷팅 유틸리티 */

export function getLocaleString(lang: string): string {
  return lang === "ko" ? "ko-KR" : "en-US";
}

export function formatCurrencyKRW(amount: number): string {
  return `₩${Math.round(amount).toLocaleString("ko-KR")}`;
}

export function formatCurrency(amount: number, currency?: string, lang = "ko"): string {
  if (!currency || currency === "KRW") return formatCurrencyKRW(amount);
  if (currency === "USD") return `$${amount.toFixed(2)}`;
  if (currency === "EUR") return `€${amount.toFixed(2)}`;
  return `${currency} ${amount.toLocaleString(getLocaleString(lang))}`;
}

export function formatWithKRW(amount: number, currency?: string, lang = "ko"): string {
  return formatCurrency(amount, currency, lang);
}

export function formatCurrencyByLang(amount: number, lang = "ko"): string {
  if (lang === "ko") return formatCurrencyKRW(amount);
  return `$${amount.toFixed(2)}`;
}

export function formatSteamPrice(cents: number, lang = "ko"): string {
  if (lang === "ko") return formatCurrencyKRW(cents / 100);
  return `$${(cents / 100).toFixed(2)}`;
}

/** 상대 시간 포맷 (예: "3시간 전", "2일 전") */
export function formatRelativeTime(timestamp: number): string {
  const now = Date.now() / 1000;
  const diff = now - timestamp;

  if (diff < 60) return "방금 전";
  if (diff < 3600) return `${Math.floor(diff / 60)}분 전`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}시간 전`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)}일 전`;
  return `${Math.floor(diff / 2592000)}개월 전`;
}

/** 플레이어 수 포맷 (예: 1.2만, 523.4만) */
export function formatPlayerCount(count: number): string {
  if (count >= 10000) return `${(count / 10000).toFixed(1)}만`;
  return count.toLocaleString("ko-KR");
}

/** 남은 시간 카운트다운 */
export function formatCountdown(endTime: number): string {
  const now = Date.now() / 1000;
  const diff = endTime - now;
  if (diff <= 0) return "종료됨";

  const days = Math.floor(diff / 86400);
  const hours = Math.floor((diff % 86400) / 3600);
  const minutes = Math.floor((diff % 3600) / 60);

  if (days > 0) return `${days}일 ${hours}시간 남음`;
  if (hours > 0) return `${hours}시간 ${minutes}분 남음`;
  return `${minutes}분 남음`;
}
